import React from 'react';
import PropTypes from 'prop-types';
import Slot from '@src/components/scheduling-provider-card/Slot.jsx';
import SlotPlaceholder from '@src/components/scheduling-provider-card/SlotPlaceholder.jsx';

/**
 * Renders appointment time slots for a single day in a vertical list.
 */
const SlotList = ({ slots, expanded }) => {
  let className = 'time-slots__day';
  if (expanded) {
    className += ' expanded';
  }

  return (
    <div className={className} data-testid='slot-list'>
      {
        slots.map((slotObj, index) => {
          if (slotObj.slot) {
            return (
              <Slot
                key={slotObj.slot}
                slot={slotObj.slot}
                durationMins={slotObj.durationMins}
                visitTypes={slotObj.visitTypes}
                accessibility={slotObj.accessibility}
                provider={slotObj.provider}
                insuranceRequirement={slotObj.insuranceRequirement}
                referralRequirement={slotObj.referralRequirement}
                appointmentNotesRequired={slotObj.appointmentNotesRequired}
                hasTelemedicine={slotObj.hasTelemedicine}
              />
            )
          }
          else {
            return (
              <SlotPlaceholder key={`blank-${index}`} />
            )
          }
        }
      )
    }
    </div>
  );
}

SlotList.propTypes = {
  /**
   * the array of time slots to show
   */
  slots: PropTypes.array.isRequired,
  /**
   * determines whether or not an abbreviated list of slots are shown
   */
  expanded: PropTypes.bool.isRequired,
};

export default SlotList;
